<template>
  <div class="con2">
    <div class="con2_title">{{ title }}</div>
    <div class="con2_tab">
      <div class="tab_box">
        <div class="list">
          <div class="list_l" @click="tabShow = 0">{{ list[0].menuTitle }}</div>
          <div @click="tabShow = 1">{{ list[1].menuTitle }}</div>
          <div class="list_r" @click="tabShow = 2">{{ list[2].menuTitle }}</div>
        </div>
        <div :class="`line active_line${tabShow}`"></div>
      </div>

      <div v-show="tabShow === index" class="tab2_con" v-for="(item, index) in list" :key="index">
        <div class="tab2_con_img" :class="`tab2_con_img-${index}`" :style="{ backgroundImage: `url(${item.img})` }"></div>
        <div class="tab2_con_text">
          <div class="text_title">{{ item.mainTitle }}</div>
          <div class="text_con">{{ item.desc }}</div>
          <div class="text_button" @click="jump(item.url)">立即接入</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    list: Array,
  },
  data() {
    return {
      tabShow: 0,
    }
  },
  methods: {
    jump(url) {
      window.open(url)
    },
  },
}
</script>

<style lang="less" scoped>
.con2 {
  width: 100%;
  height: 733px;
  background: #fafafa;
}

.con2_title {
  font-size: 36px;
  color: #333;
  padding-top: 70px;
  display: flex;
  justify-content: center;
}

.con2_tab {
  width: 1200px;
  margin: 70px auto 0;

  .tab_box {
    height: 45px;
    color: #333;
    font-size: 18px;
    font-weight: 400;
    flex-direction: row;
    border-bottom: 1px solid #e9e9e9;

    .list {
      width: 100%;
      height: 25px;
      display: flex;
      justify-content: space-between;
      cursor: pointer;

      .list_l {
        margin-left: 42px;
      }

      .list_r {
        margin-right: 144px;
      }
    }

    .line {
      width: 200px;
      height: 19px;
      border-bottom: 1px solid #e61717;
      position: relative;
    }

    .active_line1 {
      margin-left: 449px;
    }

    .active_line2 {
      margin-left: 900px;
    }
  }
}

.tab2_con {
  width: 100%;
  height: 368px;
  display: flex;

  &_img {
    width: 619px;
    height: 368px;
    background-size: cover;
    background-repeat: no-repeat;
    margin-top: 47px;
    margin-left: 113px;
  }

  &_img-2 {
    width: 358px;
    height: 410px;
    background-size: cover;
    background-repeat: no-repeat;
    margin-top: 47px;
    margin-left: 254px;
  }

  &_text {
    padding-top: 153px;
    padding-left: 41px;

    .text_title {
      font-size: 18px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #333;
      line-height: 25px;
    }

    .text_con {
      width: 417px;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #333;
      line-height: 22px;
      margin-top: 10px;
    }

    .text_button {
      width: 121px;
      height: 40px;
      background: #e61717;
      color: #fff;
      line-height: 40px;
      text-align: center;
      margin-top: 23px;
      font-size: 14px;
      display: block;
      cursor: pointer;
    }
  }
}
</style>
